function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".icon-review-date_svg__cls-1{fill:var(--main-color)}.icon-review-date_svg__cls-2{fill:#fff;stroke:var(--main-color);stroke-linecap:round;stroke-linejoin:round;stroke-width:12px}"));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "icon-review-date_svg__Layer_1",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  className: "icon-review-date_svg__cls-1",
  d: "M197.09 75.21a4.6 4.6 0 014.6 4.59v116.81a4.61 4.61 0 01-4.6 4.6H66.28a4.6 4.6 0 01-4.59-4.6V79.8a4.6 4.6 0 014.59-4.59h130.81m0-8H66.28A12.59 12.59 0 0053.69 79.8v116.81a12.6 12.6 0 0012.59 12.6h130.81a12.6 12.6 0 0012.6-12.6V79.8a12.59 12.59 0 00-12.6-12.59z"
}), /*#__PURE__*/React.createElement("path", {
  className: "icon-review-date_svg__cls-1",
  d: "M57.69 101.21V79.8a8.6 8.6 0 018.59-8.59h130.81a8.6 8.6 0 018.6 8.59v21.41z"
}), /*#__PURE__*/React.createElement("path", {
  className: "icon-review-date_svg__cls-1",
  d: "M197.09 75.21a4.6 4.6 0 014.6 4.59v17.41h-140V79.8a4.6 4.6 0 014.59-4.59h130.81m0-8H66.28A12.59 12.59 0 0053.69 79.8v25.41h156V79.8a12.59 12.59 0 00-12.6-12.59z"
}), /*#__PURE__*/React.createElement("rect", {
  className: "icon-review-date_svg__cls-1",
  x: 125.23,
  y: 129.21,
  width: 14.72,
  height: 14.72,
  rx: 0.87
}), /*#__PURE__*/React.createElement("path", {
  className: "icon-review-date_svg__cls-1",
  d: "M136 133.21v6.72h-6.73v-6.72H136m3.13-8h-13a4.86 4.86 0 00-4.87 4.86v13a4.87 4.87 0 004.87 4.87h13a4.87 4.87 0 004.87-4.87v-13a4.86 4.86 0 00-4.87-4.86z"
}), /*#__PURE__*/React.createElement("rect", {
  className: "icon-review-date_svg__cls-1",
  x: 125.23,
  y: 162.48,
  width: 14.72,
  height: 14.72,
  rx: 0.87
}), /*#__PURE__*/React.createElement("path", {
  className: "icon-review-date_svg__cls-1",
  d: "M136 166.48v6.73h-6.73v-6.73H136m3.13-8h-13a4.87 4.87 0 00-4.87 4.87v13a4.87 4.87 0 004.87 4.87h13a4.87 4.87 0 004.87-4.87v-13a4.87 4.87 0 00-4.87-4.87z"
}), /*#__PURE__*/React.createElement("rect", {
  className: "icon-review-date_svg__cls-1",
  x: 87.96,
  y: 129.21,
  width: 14.72,
  height: 14.72,
  rx: 0.87
}), /*#__PURE__*/React.createElement("path", {
  className: "icon-review-date_svg__cls-1",
  d: "M98.68 133.21v6.72H92v-6.72h6.72m3.13-8h-13a4.86 4.86 0 00-4.85 4.86v13a4.87 4.87 0 004.86 4.87h13a4.87 4.87 0 004.87-4.87v-13a4.86 4.86 0 00-4.87-4.86z"
}), /*#__PURE__*/React.createElement("rect", {
  className: "icon-review-date_svg__cls-1",
  x: 87.96,
  y: 162.48,
  width: 14.72,
  height: 14.72,
  rx: 0.87
}), /*#__PURE__*/React.createElement("path", {
  className: "icon-review-date_svg__cls-1",
  d: "M98.68 166.48v6.73H92v-6.73h6.72m3.13-8h-13a4.87 4.87 0 00-4.85 4.87v13a4.87 4.87 0 004.86 4.87h13a4.87 4.87 0 004.87-4.87v-13a4.87 4.87 0 00-4.87-4.87z"
}), /*#__PURE__*/React.createElement("rect", {
  className: "icon-review-date_svg__cls-1",
  x: 161.7,
  y: 129.21,
  width: 14.72,
  height: 14.72,
  rx: 0.87
}), /*#__PURE__*/React.createElement("path", {
  className: "icon-review-date_svg__cls-1",
  d: "M172.42 133.21v6.72h-6.72v-6.72h6.72m3.13-8h-13a4.85 4.85 0 00-4.86 4.86v13a4.86 4.86 0 004.86 4.87h13a4.87 4.87 0 004.87-4.87v-13a4.86 4.86 0 00-4.87-4.86z"
}), /*#__PURE__*/React.createElement("rect", {
  className: "icon-review-date_svg__cls-1",
  x: 161.7,
  y: 162.48,
  width: 14.72,
  height: 14.72,
  rx: 0.87
}), /*#__PURE__*/React.createElement("path", {
  className: "icon-review-date_svg__cls-1",
  d: "M172.42 166.48v6.73h-6.72v-6.73h6.72m3.13-8h-13a4.86 4.86 0 00-4.86 4.87v13a4.86 4.86 0 004.86 4.87h13a4.87 4.87 0 004.87-4.87v-13a4.87 4.87 0 00-4.87-4.87z"
}), /*#__PURE__*/React.createElement("path", {
  className: "icon-review-date_svg__cls-2",
  d: "M98.69 58.21v15M164.69 58.21v15"
}));

function SvgIconReviewDate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 259 259"
  }, props), _ref, _ref2);
}

export default SvgIconReviewDate;